import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ServerProvider } from './server';

@Injectable()
export class AtendimentoProvider {

  constructor(private _server: ServerProvider) {
  }

  public loadItems(): Observable<Array<any>> {
    let body = {
      operacao: 'ATENDIMENTO_LISTAR'
    };

    return Observable.create((observer) => {
      this._server.postData(body).subscribe(
        (data) => {
          if (data && data.atendimentos) {
            observer.next(data.atendimentos);
          } else {
            observer.next([]);
          }
          observer.complete();
        },
        (error) => { observer.error(error); }
      );
    });
  }


  public get(id): Observable<any> {
    return Observable.create((observer) => {
      this._server.postData({ operacao: 'ATENDIMENTO_VISUALIZAR', id: id }).subscribe(
        (data) => {
          if (data && data.atendimento) {
            observer.next(data.atendimento);
          } else {
            observer.next([]);
          }
          observer.complete();
        },
        (error) => { observer.error(error); }
      );
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/atendimento.ts